export var DEFAULT_COLORS = {
  NAV_BG: '#333438',
  HEADER_BG: '#fdf8d9',
  ACCENT: '#ffd400',
  // 141414 -> rgb(20,20,20)
  DARK_BUTTON_BG: '#141414',
  SLIDER_BG: '#0091ff',
  SLIDER_HOVER: '#003fc3'
};
export var DEFAULT_FONT = 'arial';
export var FONTS = [{
  label: 'Arial (sans-serif)',
  value: 'arial'
}, {
  label: 'Georgia (serif)',
  value: 'georgia'
}, {
  label: 'Fantasy (sans-serif)',
  value: 'fantasy'
}, {
  label: 'Verdana (sans-serif)',
  value: 'verdana'
}];